var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import AOPOrderbookURL from "@adapters/infrastructures/urlConfig/OrderBook/aopOrderbookURL";
import { aopOrderbookClientDetails } from "@domains/features/OrderBook/mappers/aopOrderBookClientDetailsMapper";
import { aopOrderBookClientFilter } from "@domains/features/OrderBook/mappers/aopOrderBookClientFilterMapper";
import { aopDownloadMapper } from "@domains/features/OrderBook/mappers/aopOrderBookDownloadMapper";
import { aopOrderbookMapper } from "@domains/features/OrderBook/mappers/aopOrderbookMapper";
import { getDateInFormat } from "@domains/utils/reportDates";
var AOPOrderBookRespository = /** @class */ (function () {
    function AOPOrderBookRespository(http) {
        this.http = http;
    }
    AOPOrderBookRespository.prototype.getAopOrderbookVerificationLink = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var sendReq, url, reqObj, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        sendReq = JSON.parse(JSON.stringify(req));
                        url = new URL(!!(req === null || req === void 0 ? void 0 : req.encryption) && (req === null || req === void 0 ? void 0 : req.encryption)
                            ? AOPOrderbookURL.verificationLinkV2
                            : AOPOrderbookURL === null || AOPOrderbookURL === void 0 ? void 0 : AOPOrderbookURL.verificationLink);
                        delete sendReq.encryption;
                        reqObj = {
                            applicationId: (_a = req.applicationId) !== null && _a !== void 0 ? _a : "",
                        };
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: reqObj,
                                skipAuthHeader: true,
                                encryption: !!(req === null || req === void 0 ? void 0 : req.encryption) && (req === null || req === void 0 ? void 0 : req.encryption) ? req === null || req === void 0 ? void 0 : req.encryption : false,
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, { success: response.data }];
                }
            });
        });
    };
    AOPOrderBookRespository.prototype.getAOPOrderBookClientFilterList = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var sendReq, url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sendReq = JSON.parse(JSON.stringify(req));
                        url = new URL(!!(req === null || req === void 0 ? void 0 : req.encryption) && (req === null || req === void 0 ? void 0 : req.encryption)
                            ? AOPOrderbookURL.getClientFilterDataV2
                            : AOPOrderbookURL === null || AOPOrderbookURL === void 0 ? void 0 : AOPOrderbookURL.getClientFilterData);
                        delete sendReq.encryption;
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: sendReq,
                                skipAuthHeader: true,
                                encryption: !!(req === null || req === void 0 ? void 0 : req.encryption) ? req === null || req === void 0 ? void 0 : req.encryption : false,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, aopOrderBookClientFilter(response.data)];
                }
            });
        });
    };
    AOPOrderBookRespository.prototype.getApplicationDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var sendReq, url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sendReq = JSON.parse(JSON.stringify(req));
                        url = new URL(!!(req === null || req === void 0 ? void 0 : req.encryption) && (req === null || req === void 0 ? void 0 : req.encryption)
                            ? AOPOrderbookURL.clientDetailsV2
                            : AOPOrderbookURL === null || AOPOrderbookURL === void 0 ? void 0 : AOPOrderbookURL.clientDetails);
                        delete sendReq.encryption;
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: sendReq,
                                skipAuthHeader: true,
                                encryption: !!(req === null || req === void 0 ? void 0 : req.encryption) ? req === null || req === void 0 ? void 0 : req.encryption : false,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, aopOrderbookClientDetails(response.data)];
                }
            });
        });
    };
    AOPOrderBookRespository.prototype.getAopOrderbookDashboard = function (req) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var sendReq, url, reqObj, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        sendReq = JSON.parse(JSON.stringify(req));
                        url = new URL(!!(req === null || req === void 0 ? void 0 : req.encryption) && (req === null || req === void 0 ? void 0 : req.encryption)
                            ? AOPOrderbookURL.dashboardDataV2
                            : AOPOrderbookURL === null || AOPOrderbookURL === void 0 ? void 0 : AOPOrderbookURL.dashboardData);
                        delete sendReq.encryption;
                        reqObj = {
                            pageStart: req === null || req === void 0 ? void 0 : req.pageStart,
                            pageSize: req === null || req === void 0 ? void 0 : req.pageSize,
                            inputEmpId: ((_a = req === null || req === void 0 ? void 0 : req.inputEmpId) === null || _a === void 0 ? void 0 : _a.length) > 0
                                ? req === null || req === void 0 ? void 0 : req.inputEmpId.filter(function (item) { return item !== undefined && item !== null; }).join(",")
                                : "",
                            inputClientCode: ((_b = req === null || req === void 0 ? void 0 : req.inputClientCode) === null || _b === void 0 ? void 0 : _b.length) > 0
                                ? req === null || req === void 0 ? void 0 : req.inputClientCode.filter(function (item) { return item !== undefined && item !== null; }).join(",")
                                : "",
                            fromDate: getDateInFormat(req === null || req === void 0 ? void 0 : req.fromDate, "yyyy-MM-DD"),
                            toDate: getDateInFormat(req === null || req === void 0 ? void 0 : req.toDate, "yyyy-MM-DD"),
                            isFilter: !!(req === null || req === void 0 ? void 0 : req.isFilter) ? req === null || req === void 0 ? void 0 : req.isFilter : false,
                            accountTypeId: ((_c = req === null || req === void 0 ? void 0 : req.accountTypeId) === null || _c === void 0 ? void 0 : _c.length) > 0 ? parseInt(req === null || req === void 0 ? void 0 : req.accountTypeId[0]) : 2,
                        };
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: reqObj,
                                skipAuthHeader: true,
                                encryption: !!(req === null || req === void 0 ? void 0 : req.encryption) ? req === null || req === void 0 ? void 0 : req.encryption : false,
                            })];
                    case 1:
                        response = _d.sent();
                        return [2 /*return*/, aopOrderbookMapper(response.data)];
                }
            });
        });
    };
    AOPOrderBookRespository.prototype.getDownloadAOPOrderbookList = function (req) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var sendReq, url, reqObj, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        sendReq = JSON.parse(JSON.stringify(req));
                        url = new URL(!!(req === null || req === void 0 ? void 0 : req.encryption) && (req === null || req === void 0 ? void 0 : req.encryption)
                            ? AOPOrderbookURL.downloadDataV2
                            : AOPOrderbookURL === null || AOPOrderbookURL === void 0 ? void 0 : AOPOrderbookURL.downloadData);
                        reqObj = {
                            pageStart: req === null || req === void 0 ? void 0 : req.pageStart,
                            pageSize: req === null || req === void 0 ? void 0 : req.pageSize,
                            inputEmpId: ((_a = req === null || req === void 0 ? void 0 : req.inputEmpId) === null || _a === void 0 ? void 0 : _a.length) > 0
                                ? req === null || req === void 0 ? void 0 : req.inputEmpId.filter(function (item) { return item !== undefined && item !== null; }).join(",")
                                : "",
                            inputClientCode: ((_b = req === null || req === void 0 ? void 0 : req.inputClientCode) === null || _b === void 0 ? void 0 : _b.length) > 0
                                ? req === null || req === void 0 ? void 0 : req.inputClientCode.filter(function (item) { return item !== undefined && item !== null; }).join(",")
                                : "",
                            fromDate: getDateInFormat(req === null || req === void 0 ? void 0 : req.fromDate, "yyyy-MM-DD"),
                            toDate: getDateInFormat(req === null || req === void 0 ? void 0 : req.toDate, "yyyy-MM-DD"),
                            isFilter: !!(req === null || req === void 0 ? void 0 : req.isFilter) ? req === null || req === void 0 ? void 0 : req.isFilter : false,
                            accountTypeId: ((_c = req === null || req === void 0 ? void 0 : req.accountTypeId) === null || _c === void 0 ? void 0 : _c.length) > 0 ? parseInt(req === null || req === void 0 ? void 0 : req.accountTypeId[0]) : 2,
                        };
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: reqObj,
                                skipAuthHeader: true,
                                encryption: !!(req === null || req === void 0 ? void 0 : req.encryption) && (req === null || req === void 0 ? void 0 : req.encryption) ? req === null || req === void 0 ? void 0 : req.encryption : false,
                            })];
                    case 1:
                        response = _d.sent();
                        return [2 /*return*/, aopDownloadMapper(response.data)];
                }
            });
        });
    };
    AOPOrderBookRespository.prototype.getAopOrderbookSelfieLink = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var sendReq, url, reqObj, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        sendReq = JSON.parse(JSON.stringify(req));
                        url = new URL(!!(req === null || req === void 0 ? void 0 : req.encryption) && (req === null || req === void 0 ? void 0 : req.encryption)
                            ? AOPOrderbookURL.selfieLinkDataV2
                            : AOPOrderbookURL === null || AOPOrderbookURL === void 0 ? void 0 : AOPOrderbookURL.selfieLinkData);
                        delete sendReq.encryption;
                        reqObj = {
                            applicationId: (_a = req.applicationId) !== null && _a !== void 0 ? _a : "",
                        };
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: reqObj,
                                skipAuthHeader: true,
                                encryption: !!(req === null || req === void 0 ? void 0 : req.encryption) && (req === null || req === void 0 ? void 0 : req.encryption) ? req === null || req === void 0 ? void 0 : req.encryption : false,
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, { success: response.data }];
                }
            });
        });
    };
    AOPOrderBookRespository.prototype.getAopOrderBookESignLink = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var sendReq, url, reqObj, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        sendReq = JSON.parse(JSON.stringify(req));
                        url = new URL(!!(req === null || req === void 0 ? void 0 : req.encryption) && (req === null || req === void 0 ? void 0 : req.encryption)
                            ? AOPOrderbookURL.eSignLinkDataV2
                            : AOPOrderbookURL === null || AOPOrderbookURL === void 0 ? void 0 : AOPOrderbookURL.eSignLinkData);
                        reqObj = {
                            applicationId: (_a = req.applicationId) !== null && _a !== void 0 ? _a : "",
                        };
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: reqObj,
                                skipAuthHeader: true,
                                encryption: !!(req === null || req === void 0 ? void 0 : req.encryption) && (req === null || req === void 0 ? void 0 : req.encryption) ? req === null || req === void 0 ? void 0 : req.encryption : false,
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, { success: response.data }];
                }
            });
        });
    };
    AOPOrderBookRespository.prototype.getAopOrderBookGetKyc = function (req) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var url, reqObj, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        url = new URL(!!(req === null || req === void 0 ? void 0 : req.encryption) && (req === null || req === void 0 ? void 0 : req.encryption)
                            ? AOPOrderbookURL.getKycDataV2
                            : AOPOrderbookURL.getKycData);
                        reqObj = {
                            applicationId: (_a = req.applicationId) !== null && _a !== void 0 ? _a : "",
                            accountCategory: (_b = req.accountCategory) !== null && _b !== void 0 ? _b : 2,
                            isKYCDownload: (_c = req.isKYCDownload) !== null && _c !== void 0 ? _c : false,
                        };
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: reqObj,
                                skipAuthHeader: true,
                                encryption: !!(req === null || req === void 0 ? void 0 : req.encryption) && (req === null || req === void 0 ? void 0 : req.encryption) ? req === null || req === void 0 ? void 0 : req.encryption : false,
                            })];
                    case 1:
                        response = _d.sent();
                        return [2 /*return*/, { data: response.data || "" }];
                }
            });
        });
    };
    return AOPOrderBookRespository;
}());
export default AOPOrderBookRespository;
